import { CheckCircledIcon, Cross1Icon, CrossCircledIcon, ExclamationTriangleIcon, InfoCircledIcon } from "@radix-ui/react-icons";
import { Callout, Flex, IconButton } from "@radix-ui/themes";
import type { ReactNode } from "react";

interface AlertProps {
    type?: "info" | "success" | "warning" | "error";
    message?: string;
    children?: ReactNode;
    onClose?: () => void;
}

function Alert({ type = "info", message, children, onClose }: AlertProps) {
    let color: "blue" | "green" | "amber" | "red" = "blue";
    let Icon = InfoCircledIcon;

    switch (type) {
        case "success":
            color = "green";
            Icon = CheckCircledIcon;
            break;
        case "warning":
            color = "amber";
            Icon = ExclamationTriangleIcon;
            break;
        case "error":
            color = "red";
            Icon = CrossCircledIcon;
            break;
    }

    return (
        <Callout.Root
            color={color}
            style={{
                marginBottom: "16px",
                padding: "var(--space-2)",
            }}
        >
            <Flex align="center" gap="3">
                <Callout.Icon>
                    <Icon />
                </Callout.Icon>
                <Callout.Text
                    style={{
                        flex: 1,
                    }}
                >
                    {message || children}
                </Callout.Text>
                {onClose && (
                    <IconButton
                        variant="ghost"
                        color={color}
                        onClick={onClose}
                        size="1"
                        style={{
                            margin: "-4px",
                        }}
                    >
                        <Cross1Icon />
                    </IconButton>
                )}
            </Flex>
        </Callout.Root>
    );
}

export default Alert;
